import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box } from 'grommet'

import NumberBoard from './numberBoard'
import { setChoices } from '../../redux/rng/actions'
import { usePersistValue } from '../../hook/usePersistValue'

const NumberContainer = ({ onFloating = false }) => {
  const results = useSelector(state => state.rng.resultsArray)
  const boardIndex = useSelector(state => state.rng.boardIndex)
  const digitRanges = useSelector(state => state.rng.digitRanges)
  const { value: typeOption } = usePersistValue(state => state.rng.typeOption)
  const [objects, setObjects] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const numberings = ['1st', '2nd', '3rd', '4th', '5th', '6th']
    let tempObjects = []
    if (results) {
      for (let i = 0; i < results.length; i++) {
        tempObjects.push({
          result: results[i],
          numbering: numberings[i],
          selected: boardIndex === i && results[i] === null,
        })
      }
    }
    setObjects([...tempObjects])
  }, [results, boardIndex])

  useEffect(() => {
    setDigitChoices(boardIndex)
  }, [digitRanges])

  const setDigitChoices = index => {
    const newChoices = Array.from(
      { length: digitRanges[index][1] - digitRanges[index][0] + 1 },
      (_, i) => i + digitRanges[index][0],
    )
    dispatch(setChoices(newChoices))
  }
  return (
    <Box
      direction="row-reverse"
      gap=".5rem"
      alignSelf="stretch"
      justify="center"
      margin={{
        bottom: !onFloating ? '2.5rem' : '0rem',
        top: !onFloating ? '1.5rem' : '0rem',
      }}
      style={{ display: typeOption > 0 ? 'flex' : 'none' }}
      // width={!onFloating ? '50rem' : '34.5rem'}
    >
      {objects.map((object, index) => {
        // return !onFloating ? (
        return (
          <NumberBoard
            object={object}
            index={index}
            key={`NumberBoard${index}`}
            onFloating={onFloating}
            setDigitChoices={setDigitChoices}
          />
        )
        // ) : (
        // <NumberBoardWheel
        //   object={object}
        //   index={index}
        //   key={`NumberBoard${index}`}
        // />
        // )
      })}
    </Box>
  )
}

export default NumberContainer
